<template>
	<div>
		<ed-form :data="formData" :config="config" :response="response" :itens="exameItems">
			<div slot="form-footer">
				<Laboratorios :parent="this"/>
			</div>
		</ed-form>
	</div>
</template>

<script>

	import Rest from 'common/rest';
	import EdForm from 'common/form';
	import FormItems  from './_form/risco-cadastrar';
	import Laboratorios from './_includes/laboratorio'

  	export default {
  		name:"ltcat-risco-cadastrar",
  		components: {EdForm,Laboratorios},
		mixins:[Rest],
		watch: {
		},
  		data () {
		   	return {
				config:{
					tipo:[269,290],
					hidden:{
					},
					click:{
						save:this.salvar,
						id_tab:this.getTabelaDinamica,
						esocial_atividade_per: this.getEscocialTabela28,
					},
					loading:{
						save:false,
						id_tab:false,
						esocial_atividade_per: false,
					},
					list:{
						id_tab:[],
						esocial_atividade_per: [],
					}
				},
		   		formData:{
		   			id:0,
					nome:null,
					nome_comercial:null,
		   			cod_cas:null,
					cod_esocial:'00.00.000',
		   			cod_metodologia:null,
					desc_metodologia:null,
					id_tipo_unidade_medida:null,
					id_tab:null,
					un_medida:null,
					amostra:null,
					vazao:null,
					volume:null,
					cod_amostrador:null,
					desc_amostrador:null,
					usuario:null,
					laboratorio:null,
					id_lab:null,
					laboratorios:[],
					        esocial_atividade_per: [],
					ativo:1,
		   		},
				response:{},
				exameItems:[],
			}
		},

		mounted: function() {
			this.exameItems = FormItems;
			this.getTabelaDinamica();
			this.getEscocialTabela28();
		},

		methods: {

			onChangeProprio: function(){
			},
			
			    getEscocialTabela28: function (_search) {
      this.config.loading.esocial_atividade_per = true;
      this.config.list.esocial_atividade_per = [];

      this.get("/esocial/tabelas/conteudo/28", { search: _search }).then(
        (result) => {
          result = result[0];

          this.config.loading.esocial_atividade_per = false;

          if (result.status == 200) {
            this.config.list.esocial_atividade_per = result.data.data;
          }
        }
      );
    },

			getTabelaDinamica(_search){

				this.config.loading.id_tab = true;
				this.config.list.id_tab  = [];

				this.get('/ltcat/tabela-dinamica',{search:_search}).then((result)=>{

					result = result[0];

					this.config.loading.id_tab = false;

		            if(result.status == 200){
						this.config.list.id_tab = result.data.data;
		             }
	            });
			},

			salvar: function(){

				this.response = {};
				this.config.loading.save = true;

				this.post('fator-risco/editar',this.formData).then((result)=>{

					result = result[0];

					this.config.loading.save = false;
					this.response = result;

					if(result.status == 200){

						this.$message({
							message: 'Registro salvo com sucesso!',
							type: 'success'
						});

						this.toRoute({name:'ltcat.risco.editar',params:{id:result.data.id}});
					}

				});
			}
		}
  	}
</script>


// WEBPACK FOOTER //
// cadastrar.vue?05107edc